import React, { useState } from "react";

const YouTubePlayer = () => {
  const [videoId, setVideoId] = useState(""); // To store the video ID
  const [inputValue, setInputValue] = useState(""); // To capture the YouTube link input
  const [playerCount, setPlayerCount] = useState(1); // To capture the number of players

  // Extract the video ID, including YouTube Shorts
  const extractVideoId = (url) => {
    const regExp = /^.*(youtu.be\/|v\/|\/u\/\w\/|embed\/|watch\?v=|shorts\/|watch\/|&v=)([^#\&\?]*).*/;
    const match = url.match(regExp);
    return match && match[2].length === 11 ? match[2] : null;
  };

  // Handle input change for YouTube link
  const handleInputChange = (event) => {
    setInputValue(event.target.value);
  };

  // Handle input change for player count
  const handlePlayerCountChange = (event) => {
    setPlayerCount(Number(event.target.value));
  };

  // When the "Play Video" button is clicked
  const handlePlayClick = () => {
    const id = extractVideoId(inputValue);
    if (id) {
      setVideoId(id);
    } else {
      alert("Invalid YouTube or Shorts link. Please enter a valid one.");
    }
  };

  return (
    <div>
      <h1>YouTube Video Player</h1>

      {/* Input for YouTube video link */}
      <input
        type="text"
        value={inputValue}
        onChange={handleInputChange}
        placeholder="Enter YouTube or Shorts link"
      />

      {/* Input for the number of players */}
      <input
        type="number"
        value={playerCount}
        onChange={handlePlayerCountChange}
        placeholder="Number of Players"
        min="1"
      />

      {/* Button to play the video */}
      <button onClick={handlePlayClick}>Play Video</button>

      {/* Display multiple YouTube players based on the input count */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: `repeat(auto-fill, minmax(150px, 1fr))`,
          gap: "20px",
          marginTop: "20px",
          height: "50vh",
          overflow: "hidden",
        }}
      >
        {videoId &&
          Array.from({ length: playerCount }).map((_, index) => (
            <div key={index} style={{ width: "autoflex", height: "auto" }}>
              <iframe
                width="100%"
                height="390"
                src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
                title={`YouTube Video Player ${index + 1}`}
                allow="autoplay; encrypted-media"
                allowFullScreen
                frameBorder="0"
                sandbox="allow-scripts allow-same-origin allow-popups allow-presentation"
              ></iframe>
            </div>
          ))}
      </div>
    </div>
  );
};

export default YouTubePlayer;
